import { BASE_URL } from "./api";

export const SocketEvents = {
  Message: "message",
  Connection: "connection",
  Join: "join",
  Leave: "leave",
  ConversationMessage: "conversation:message",
  ConversationMessageDeleted: "conversation:message-deleted",
  ConversationUpdated: "conversation:updated",
  ConversationRead: "conversation:read",
  NotificationNew: "notification:new",
  NotificationRead: "notification:read",
  NotificationSync: "notification:sync",
  CarChanged: "car:changed",
};

export const SocketURL = (): string => BASE_URL.replace(/\/api\/v1\/?$/, "");

export const getConversationRoom = (conversationId: string): string =>
  `conversation:${conversationId}`;

export const getUserRoom = (userId: string): string => `user:${userId}`;
